import { HttpService } from '../../http';
import { IWindowResources } from '../window-resources.interface';
import { InterestConfiguration } from './interest-configuration.interface';
import { InterestEntity } from './interest-entity.interface';

export class InterestResource {

    private static instance: InterestResource;
    private readonly http: HttpService;
    private readonly categoryEndpoint: string;
    private readonly ticketAlarmEndpoint: string;
    private readonly venueEndpoint: string;

    constructor(
        readonly configuration: InterestConfiguration
    ) {
        this.http = HttpService.getInstance(configuration);
        this.categoryEndpoint = this.configuration.userSubscriptionRootPath + 'category-interests.html';
        this.venueEndpoint = this.configuration.userSubscriptionRootPath + 'venue-interests.html';
        this.ticketAlarmEndpoint = this.configuration.userSubscriptionRootPath + 'ticket-alarm-interests.html';
    }

    public static getInstance(configuration: InterestConfiguration): InterestResource {
        const windowInstance = this.getDOMInstance();
        if (windowInstance && windowInstance.configuration.clientId === configuration.clientId) {
            return windowInstance;
        }

        if (!this.instance) {
            const win = window as IWindowResources & typeof globalThis;
            this.instance = new InterestResource(configuration);

            win.DWSResources = {
                ...win.DWSResources,
                Interest: this.instance,
            };

        }

        return this.instance;
    }

    private static getDOMInstance(): InterestResource | undefined {
        const win: IWindowResources = window as IWindowResources & typeof globalThis;
        return win && win.DWSResources !== undefined ? win.DWSResources.Interest : undefined;
    }

    public async getCategoryInterestsFor(name?: string): Promise<InterestEntity[]> {
        try {
            const requestPromise = await this.http.get<InterestEntity[]>(this.categoryEndpoint, { params: { name: name } });
            return Promise.resolve(requestPromise.data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public async getTicketAlarmInterestsFor(name?: string): Promise<InterestEntity[]> {
        try {
            const requestPromise = await this.http.get<InterestEntity[]>(this.ticketAlarmEndpoint, { params: { name: name } });
            return Promise.resolve(requestPromise.data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public async getVenueInterestsFor(name?: string): Promise<InterestEntity[]> {
        try {
            const requestPromise = await this.http.get<InterestEntity[]>(this.venueEndpoint, { params: { name: name } });
            return Promise.resolve(requestPromise.data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
